import { render, staticRenderFns } from "./CompanySearch.vue?vue&type=template&id=44ca83ca"
import script from "./CompanySearch.vue?vue&type=script&lang=js"
export * from "./CompanySearch.vue?vue&type=script&lang=js"
import style0 from "./CompanySearch.vue?vue&type=style&index=0&id=44ca83ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports